// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BulkEditTable-styles___tableContainer--fdie_ {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  font-family: Arial, sans-serif;
  margin-bottom: 8px;
}

table {
  width: 100%;
  border-collapse: collapse; 
}

th, td {
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  white-space: nowrap; 
}

th {
  background-color: #ffffff;
  font-weight: bold;
  padding: 10px 12px 5px 12px;
}

thead tr {
  border-bottom: 2px solid black
}

td {
  background-color: #fff;
  padding: 12px;
}

.components-BulkEditTable-styles___tableRow--LIbth:hover td{
  background-color: #f5f5f5;
  cursor: pointer;
}

.components-BulkEditTable-styles___tableRow--LIbth:hover td input {
  background-color: #f5f5f5;
  cursor: pointer;
}

.components-BulkEditTable-styles___disabledRow--NBJ0m td {
  background-color: #e0e0e0;
  color: #a0a0a0;
  cursor: not-allowed;
}

.components-BulkEditTable-styles___selectAllHeader--mUfgy {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

`, "",{"version":3,"sources":["webpack://./components/BulkEditTable/styles.pcss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":[".tableContainer {\n  width: 100%;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  font-family: Arial, sans-serif;\n  margin-bottom: 8px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse; \n}\n\nth, td {\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n  white-space: nowrap; \n}\n\nth {\n  background-color: #ffffff;\n  font-weight: bold;\n  padding: 10px 12px 5px 12px;\n}\n\nthead tr {\n  border-bottom: 2px solid black\n}\n\ntd {\n  background-color: #fff;\n  padding: 12px;\n}\n\n.tableRow:hover td{\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n\n.tableRow:hover td input {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n\n.disabledRow td {\n  background-color: #e0e0e0;\n  color: #a0a0a0;\n  cursor: not-allowed;\n}\n\n.selectAllHeader {\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `components-BulkEditTable-styles___tableContainer--fdie_`,
	"tableRow": `components-BulkEditTable-styles___tableRow--LIbth`,
	"disabledRow": `components-BulkEditTable-styles___disabledRow--NBJ0m`,
	"selectAllHeader": `components-BulkEditTable-styles___selectAllHeader--mUfgy`
};
module.exports = ___CSS_LOADER_EXPORT___;
